import TwoColumnLayout from "../../primitives/TwoColumnLayout"
import {
  ProductHeroMediaSkeleton,
  ProductHeroInfoCardSkeleton,
  ProductHeroAccordionsSkeleton
} from "./ProductHero"

/**
 * Full-page loading state for the Product Hero. Composes the same skeleton
 * sections used by <ProductHero loading />, so the two never drift apart.
 */
const ProductHeroSkeleton = () => (
  <TwoColumnLayout
    left={<ProductHeroMediaSkeleton />}
    right={
      <div className="flex flex-col gap-6">
        <ProductHeroInfoCardSkeleton />
        <ProductHeroAccordionsSkeleton />
      </div>
    }
  />
)

ProductHeroSkeleton.displayName = "ProductHeroSkeleton"

export { ProductHeroSkeleton }
export default ProductHeroSkeleton
